import { Text } from '@awaze/design-system.components.text';
import { breakpoints, pxToRems } from '@awaze/design-system.utils.react';
import styled, { css } from 'styled-components';
export const StyledPrice = styled.div `
  color: ${({ theme }) => theme.ColorGrey900};
  font-size: ${({ theme }) => pxToRems(theme.FontHeadingHeading400FontSize)};
  font-family: ${({ theme }) => theme.FontHeadingHeading400FontFamily};
  line-height: ${({ theme }) => pxToRems(theme.FontHeadingHeading400LineHeight)};
  font-weight: ${({ theme }) => theme.FontHeadingHeading400FontWeight};
`;
export const StyledPriceFrom = styled(Text) `
  margin-right: ${pxToRems(4)};
  color: ${({ theme }) => theme.ColorGrey700};
`;
export const StyledBullet = styled.span `
  margin: 0 ${pxToRems(5)};
  font-size: ${pxToRems(11)};
  color: ${({ theme }) => theme.ColorGrey500};
`;
export const StyledPriceWrap = styled.div `
  display: flex;
  align-items: center;
`;
export const StyledPriceUnavailable = styled.p `
  display: block;
  font-size: ${({ theme }) => pxToRems(theme.FontTextText200FontSize)};
  line-height: ${({ theme }) => pxToRems(theme.FontTextText200LineHeight)};
  font-weight: ${({ theme }) => theme.FontTextText200FontWeight};
  padding-bottom: 0;
  text-align: right;
  width: 100%;
  margin: 0;

  ${({ isResponsive }) => isResponsive &&
    css `
      @media (min-width: ${breakpoints[0]}px) {
        margin-bottom: ${pxToRems(8)};
      }
    `}
`;
export const StyledWasPrice = styled.span `
  display: flex;
  align-items: flex-start;
  margin-right: ${pxToRems(4)};
  font-size: ${({ theme }) => pxToRems(theme.FontTextText400MidFontSize)};
  line-height: ${({ theme }) => pxToRems(theme.FontTextText400MidLineHeight)};
  font-weight: ${({ theme }) => theme.FontTextText400MidFontWeight};
  color: ${({ theme }) => theme.ColorStatusAttention400};
`;
export const StyledWasPriceAmount = styled.span `
  text-decoration: line-through;
`;
export const StyledPriceDuration = styled.div `
  display: flex;
  justify-content: space-between;
  width: 100%;

  ${({ isResponsive }) => isResponsive &&
    css `
      @media (min-width: ${breakpoints[0]}px) {
        display: block;
        text-align: right;

        ${StyledPrice} {
          font-size: ${({ theme }) => pxToRems(theme.FontHeadingHeading300FontSize)};
          line-height: ${({ theme }) => pxToRems(theme.FontHeadingHeading300LineHeight)};
        }

        ${StyledPriceFrom} {
          margin-right: 0;
        }

        ${StyledPriceWrap} {
          flex-direction: column;
          align-items: flex-end;
          margin-bottom: ${pxToRems(12)};
        }

        ${StyledWasPrice} {
          margin-right: 0;
        }
      }
    `}
`;
//# sourceMappingURL=property-card-price.styles.js.map